import Minus from '@bits/icons/Minus';
import Plus from '@bits/icons/Plus';
import SimpleBlockContent from '@bits/SimpleBlockContent';
import useWindowDimensions from '@utils/hooks/useWindowDimension';
import iub from '@utils/ImageUrlBuilder';
import React, { FunctionComponent } from 'react';

import styles from './index.module.scss';
interface Size {
  width: number | undefined;
  height: number | undefined;
}
type Props = {
  data;
  activeTab;
  onClick;
};

const AccordionInnerTab: FunctionComponent<Props> = ({ data, activeTab, onClick }) => {
  const active = data._key === activeTab;
  const size: Size = useWindowDimensions();

  return (
    <div className={`${styles.root} ${active ? styles['_active'] : ''}`}>
      <div className={styles['_top-wrapper']} onClick={() => onClick(data._key)}>
        {data.title}
        {active ? <Minus /> : <Plus />}
      </div>

      {active ? (
        <div className={styles.contentWrapper}>
          {data?.image?.asset ? (
            <div
              style={{
                backgroundImage: `url(${iub(data.image.asset)
                  .width(size.width <= 768 ? 600 : 1000)
                  .url()})`,
              }}
              title={data?.image?.alt}
              className={styles.img}
            />
          ) : null}

          <div className={styles.textBlock}>
            <SimpleBlockContent data={data.text} />
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default React.memo(AccordionInnerTab);
